import React from "react";
import DetalleCard from "~business/Cards/DetalleCard.tsx";

import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import ItemInputCard from "~business/Cards/ItemInputCard.tsx";
import ItemDateCard from "~business/Cards/ItemDateCard.tsx";
import { motivoAnulacionOptions } from "~constants/endosos";

const useReduxSelector = () =>
  useSelector((state) => {
    const datosAnulacion = state.detallePolizaReducer.currentPoliza
      ? state.detallePolizaReducer.currentPoliza.datosAnulacion
      : {};

    return {
      ...datosAnulacion,
    };
  });

const title = "Informacion sobre Anulación";

const DatosAnulacionCard = ({ isLoading }) => {
  const { fechaAnulacion, motivoAnulacion } = useReduxSelector();

  return (
    <DetalleCard title={title} IconHeader={CancelIcon}>
      <ItemDateCard
        readOnly
        isLoading={isLoading}
        label="Fecha Anulación"
        value={fechaAnulacion}
      />
      <ItemInputCard
        label="Motivo Anulación"
        isLoading={isLoading}
        value={
          motivoAnulacionOptions[motivoAnulacion]
            ? motivoAnulacionOptions[motivoAnulacion]
            : motivoAnulacion
        }
        readOnly
      />
    </DetalleCard>
  );
};

export default DatosAnulacionCard;
